import React from "react";
import { Field } from "formik";
import CreatableSelect from "react-select/creatable";

export interface SelectOption {
  label: string;
  value: string;
}

export interface FormikMultiCreateSelectProps {
  options: SelectOption[];
  name: string;
  value: string[];
  noOptionsMessage?: string;
  // should return true or false for valid
  validationFunc?: any;
  customErr?: string;
  placeholder?: string;
}
export interface FormikMultiCreateSelectState {
  selectedOptions: any;
  err: string;
}

// tslint:disable:max-line-length
export class FormikMultiCreateSelect extends React.Component<
  FormikMultiCreateSelectProps,
  FormikMultiCreateSelectState
> {
  constructor(props: FormikMultiCreateSelectProps) {
    super(props);
    console.log(props);
    this.state = {
      selectedOptions: null,
      err: null,
    };
    if (this.props.value) {
      this.state = {
        selectedOptions: this.props.value.map((val: string) => {
          return {
            label: val,
            value: val,
          };
        }),
        err: null,
      };
    }
    this.handleChange = this.handleChange.bind(this);
  }

  public handleChange(selectedOptions: SelectOption[], form: any) {
    this.setState({
      err: null,
    });
    let isValid = true;
    const errMsg = this.props.customErr ? this.props.customErr : "There was a problem with your input";
    if (this.props.validationFunc && selectedOptions) {
      selectedOptions.forEach((option: SelectOption) => {
        isValid = this.props.validationFunc(option.value);
      });
    }
    if (!isValid) {
      this.setState({
        err: errMsg,
      });
      return;
    }
    this.setState({ selectedOptions }, () => console.log("Option selected:", this.state.selectedOptions));
    form.setFieldValue(
      this.props.name,
      selectedOptions
        ? selectedOptions.map((selectOption: SelectOption) => {
            return selectOption.value;
          })
        : [],
    );
  }

  public render() {
    const { selectedOptions } = this.state;

    return (
      <>
        <Field name={this.props.name}>
          {({ form }: { field: any; form: any }) => (
            <CreatableSelect
              createOptionPosition="first"
              isClearable={true}
              isMulti={true}
              value={selectedOptions}
              onChange={(opts) => {
                this.handleChange(opts as SelectOption[], form);
              }}
              options={this.props.options}
              noOptionsMessage={() => this.props.noOptionsMessage}
              placeholder={this.props.placeholder}
            />
          )}
        </Field>
        {this.state.err && <div className="form-feedback">{this.state.err}</div>}
      </>
    );
  }
}
